import _styled from "@emotion/styled/base";
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import React from 'react';
import PropTypes from 'prop-types';
import { IconButton } from '../Buttons';
import { jsx as ___EmotionJSX } from "@emotion/react";
const StyledCloseButton = /*#__PURE__*/_styled(IconButton, {
  target: "ew874i00",
  label: "StyledCloseButton"
})(process.env.NODE_ENV === "production" ? {
  name: "xyzkeb",
  styles: "align-self:flex-start"
} : {
  name: "xyzkeb",
  styles: "align-self:flex-start",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9Ub2FzdC9DbG9zZUJ1dHRvbi5qc3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBTTRDIiwiZmlsZSI6Ii4uLy4uLy4uL3NyYy9Ub2FzdC9DbG9zZUJ1dHRvbi5qc3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnO1xuaW1wb3J0IFByb3BUeXBlcyBmcm9tICdwcm9wLXR5cGVzJztcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcblxuaW1wb3J0IHsgSWNvbkJ1dHRvbiB9IGZyb20gJy4uL0J1dHRvbnMnO1xuXG5jb25zdCBTdHlsZWRDbG9zZUJ1dHRvbiA9IHN0eWxlZChJY29uQnV0dG9uKWBcbiAgYWxpZ24tc2VsZjogZmxleC1zdGFydDtcbmA7XG5cblN0eWxlZENsb3NlQnV0dG9uLmRlZmF1bHRQcm9wcyA9IHtcbiAgaWNvbjogJ2Nsb3NlJyxcbn07XG5cbmZ1bmN0aW9uIENsb3NlQnV0dG9uKHsgY2xvc2VUb2FzdCwgYXJpYUxhYmVsIH0pIHtcbiAgZnVuY3Rpb24gaGFuZGxlQ2xpY2soZSkge1xuICAgIGUucHJldmVudERlZmF1bHQoKTtcbiAgICBlLnN0b3BQcm9wYWdhdGlvbigpO1xuICAgIGNsb3NlVG9hc3QoKTtcbiAgfVxuXG4gIHJldHVybiA8U3R5bGVkQ2xvc2VCdXR0b24gb25DbGljaz17aGFuZGxlQ2xpY2t9IGFyaWFMYWJlbD17YXJpYUxhYmVsfSAvPjtcbn1cblxuQ2xvc2VCdXR0b24ucHJvcFR5cGVzID0ge1xuICBjbG9zZVRvYXN0OiBQcm9wVHlwZXMuZnVuYyxcbiAgYXJpYUxhYmVsOiBQcm9wVHlwZXMuc3RyaW5nLFxufTtcblxuQ2xvc2VCdXR0b24uZGVmYXVsdFByb3BzID0ge1xuICBhcmlhTGFiZWw6ICdjbG9zZScsXG59O1xuXG5leHBvcnQgZGVmYXVsdCBDbG9zZUJ1dHRvbjtcbiJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
StyledCloseButton.defaultProps = {
  icon: 'close'
};
function CloseButton({
  closeToast,
  ariaLabel
}) {
  function handleClick(e) {
    e.preventDefault();
    e.stopPropagation();
    closeToast();
  }
  return ___EmotionJSX(StyledCloseButton, {
    onClick: handleClick,
    ariaLabel: ariaLabel
  });
}
CloseButton.propTypes = {
  closeToast: PropTypes.func,
  ariaLabel: PropTypes.string
};
CloseButton.defaultProps = {
  ariaLabel: 'close'
};
export default CloseButton;